import React, { Component, Fragment } from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { login } from "../../actions/users";
import { setAlert } from "../../actions/alerts";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  handleSubmit(e) {
    e.preventDefault();
    if (this.state.email === "") {
      this.props.setAlert("Email is required", "danger");
      return;
    }
    
    if (this.state.password === "") {
      this.props.setAlert("Passwords is required", "danger");
      return;
    }
   
    this.props.login(
      this.state.email,
      this.state.password,
    );
  }
 
  render() {
    if(this.props.auth) {
      return <Redirect to='/dashboard' />
    }
    return (
      <Fragment>
        <div className="oi-flex-wrapper">
          <div className="oi-flex-content">
            <div className="oi-card">
              <div className="form-wrapper">
                <div className="oi-form-group">
                  <label className="secondary-header-text" htmlFor="email">
                    Email
                  </label>
                  <input
                    className="oi-input"
                    type="text"
                    name="email"
                    placeholder="Enter your email"
                    value={this.state.email}
                    onChange={this.handleChange}
                  />
                  <small className="form-error">Required field</small>
                </div>

                <div className="oi-form-group margin-top-big">
                  <label className="secondary-header-text" htmlFor="email">
                    Password
                  </label>
                  <input
                    className="oi-input"
                    type="password"
                    name="password"
                    placeholder="Enter your password"
                    value={this.state.password}
                    onChange={this.handleChange}
                  />
                  <small className="form-error">Required field</small>
                </div>

                <div className="button-wrapper">
                  <button
                    onClick={this.handleSubmit}
                    className="oi-button oi-big-button margin-top-small"
                  >
                    Login
                  </button>
                  <p className="link-information">
                    Don't have an account?{" "}
                    <Link className="btn-link link-text" to="/register">
                      Register
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.users.isAuthenticated
})

export default connect(mapStateToProps, { login, setAlert })(Login);
